import type { Editor } from '@tiptap/react'
import { Extension } from '@tiptap/react'

export const TableKeyboardDeletionExtension = Extension.create({
    name: 'tableKeyboardDeletion',

    addKeyboardShortcuts() {
        return {
            Backspace: () => deleteTableBeforeCursor(this.editor),
            Delete: () => deleteTableBeforeCursor(this.editor)
        }
    }
})

function deleteTableBeforeCursor(editor: Editor): boolean {
    const { selection } = editor.state

    if (!selection.empty) {
        return false
    }

    const { $from } = selection

    if (!$from.parent.isTextblock || $from.parentOffset !== 0 || $from.depth === 0) {
        return false
    }

    const containerDepth = $from.depth - 1
    const containerNode = $from.node(containerDepth)
    const currentNodeIndex = $from.index(containerDepth)

    if (currentNodeIndex === 0) {
        return false
    }

    const previousSiblingNode = containerNode.child(currentNodeIndex - 1)

    if (previousSiblingNode.type.name !== 'table') {
        return false
    }

    const currentNodeStart = $from.before($from.depth)
    const previousNodeStart = currentNodeStart - previousSiblingNode.nodeSize

    editor.view.dispatch(editor.state.tr.delete(previousNodeStart, currentNodeStart))

    return true
}
